export default "__VITE_ASSET__CMS2P7o3__"